var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 py-2 rounded-full text-red-700 bg-red-200",attrs:{"title":"Retrieval Query"}},[_c('ViewGridIcon',{class:_vm.dropdown ? 'w-4 h-4' : 'w-6 h-6'})],1)}
var staticRenderFns = []

export { render, staticRenderFns }